import Header from "./components/Header";
import Footer from "../../components/Shared/Footer";
import SharedDynamicPage from "../../pages/DynamicPage";

export default function Homepage() {
  return (
    <>
      <Header />
      <SharedDynamicPage />
      <Footer />
    </>
  );
}
